export const handlePriceByComma = (price) => {
  return new Intl.NumberFormat('en-US').format(Number(price).toFixed(2));
};

export const formatDate = (
  date,
  dateFormat = 'short',
  timeFormat = 'short',
  mode = 'datetime',
  locale = 'en-US'
) => {
  // Parse the date
  const dateObject = new Date(date);
  if (isNaN(dateObject.getTime())) {
    // Handle invalid date
    console.error('Invalid date provided:', date);
    return 'Invalid date';
  }

  // Determine the locale
  const resolvedLocale = locale.includes('ar') ? 'ar' : 'en-US';

  // Configure date formatter
  const dateFormatter = new Intl.DateTimeFormat(resolvedLocale, {
    month: dateFormat.includes('M') ? 'long' : 'short',
    day: dateFormat.includes('d') ? '2-digit' : 'numeric',
    year: dateFormat.includes('y') ? 'numeric' : undefined,
  });

  // Configure time formatter
  const timeFormatter = new Intl.DateTimeFormat(resolvedLocale, {
    hour: timeFormat.includes('h') ? 'numeric' : undefined,
    minute: timeFormat.includes('m') ? 'numeric' : undefined,
    second: timeFormat.includes('s') ? 'numeric' : undefined,
    hour12: timeFormat.includes('a') ? true : false,
  });

  // Format date and time
  const formattedDate = dateFormatter.format(dateObject);
  const formattedTime = timeFormatter.format(dateObject);

  // Return based on mode
  switch (mode) {
    case 'time':
      return formattedTime;
    case 'date':
      return formattedDate;
    case 'datetime':
    default:
      return `${formattedDate} ${formattedTime}`.trim();
  }
};
